module.exports = __webpack_public_path__ + "static/media/driving_800_500.213f8695.jpg";